import type { PortfolioNewView } from "@buildpy/core/views/g4a/portfolio-new";
import { Link } from "@/lib/nav";

import SectionCard from "@buildpy/ui/section-card";
import { Button } from "@buildpy/ui/button";
import PortfolioForm from "@/modules/portfolio/ui/portfolio-form";
import PageHeader from "@/shell/page-header";

/** 시공사례 등록. 필수는 제목 하나 — 사진은 나중에 채워도 목록에 남는다. */
const Page = ({ data }: { data: PortfolioNewView }) => {
  const { designers, spaceOptions } = data;

  return (
    <>
      <PageHeader
        actions={
          <Button asChild size="sm" variant="outline">
            <Link href="/app/portfolio">목록</Link>
          </Button>
        }
        description="사진 주소만 붙여 넣으면 됩니다. 업로드는 저장소가 붙으면 추가합니다."
        title="시공사례 등록"
      />

      <SectionCard as="div" className="lg:p-6">
        <PortfolioForm designers={designers} spaceOptions={spaceOptions} />
      </SectionCard>
    </>
  );
};

export default Page;
